import React from 'react'
import './aboutCards.css'
import Links from './../Links/links';

const AboutCards = ({content, path, linkStyle, img, target, cardStyle}) => {
  return <div style={cardStyle} className='about__card fsba'>
    <div className="about__card-img">
        <img src={img} alt="" />
    </div>
    <div className='about__card-content'>
        <p className='about__card-text'>{content}</p>
        <Links
            style={linkStyle}
            text='Click Here'
            path={path}
            target={target}
        />
    </div>
  </div>
}

export default AboutCards